import { render, staticRenderFns } from "./VoucherDetails.vue?vue&type=template&id=6646028b&scoped=true"
import script from "./VoucherDetails.vue?vue&type=script&lang=js"
export * from "./VoucherDetails.vue?vue&type=script&lang=js"
import style0 from "./VoucherDetails.vue?vue&type=style&index=0&id=6646028b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6646028b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VContainer,VDivider})
